.banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border-radius: var(--radius-md);
  font-size: var(--text-caption);
  line-height: 1.45;
  color: var(--c-text-primary);
}

.text {
  min-width: 0;
}

.aside {
  margin-left: auto;
  font-size: 12px;
  color: var(--c-text-tertiary);
  white-space: nowrap;
}

.info {
  background: var(--c-info-subtle);
}

.info .icon {
  color: var(--c-text-secondary);
}

.warn {
  background: var(--c-warning-subtle);
}

.warn .icon {
  color: var(--c-warning);
}

.neg {
  background: var(--c-negative-subtle);
}

.neg .icon {
  color: var(--c-negative);
}

.pos {
  background: var(--c-positive-subtle);
}

.pos .icon {
  color: var(--c-positive);
}

.brand {
  background: var(--c-brand-subtle);
}

.brand .icon {
  color: var(--c-brand-muted);
}
